import { render, staticRenderFns } from "./OpenLinkComponent.vue?vue&type=template&id=2b43262d&scoped=true&"
import script from "./OpenLinkComponent.vue?vue&type=script&lang=js&"
export * from "./OpenLinkComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b43262d",
  null
  
)

export default component.exports